module.exports = __webpack_public_path__ + "static/avatar-atanas-e7303eaa5e306f7d0f1eb903d8d831de.jpg";